import React, { useState, useEffect } from "react";
import { REDIRECTURL } from "../../../backend";

function SubscriptionSuccess() {

useEffect(()=>{
    setTimeout(()=>{

        window.location.replace(REDIRECTURL);
    },4000)
    // window.location.replace('https://athenafintech.com/');
    },[])
  
  return (
    <>
      <div className="container-fluid pt-8">
      <div className="cardsucess bodysucess justify-content-center">
      <div className="divsucess" style={{height:'100px',width:'100px'}}>
        <i className="checkmark isucess" style={{lineHeight:'100px',fontSize:'50px',marginLeft:'-7px'}}>✓</i>
      </div>

      <h1 className="hsucess"> </h1> 
        <p className="psucess">Thank you for Register. You're registered successfully. 
                Please check your email for login instructions.</p><br/>
       {/* <button type="button" class="btn btn-primary btn-lg"
       onClick={()=> navigate('/login')}
       >Go to your dashboard</button> */}
      </div>
      </div>

    </>
  );
}

export default SubscriptionSuccess;
